import { Component } from '@angular/core';
import {NgIf} from "@angular/common";
import {AppLoaderService} from "../../core/services/app-loader/app-loader.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-app-loader',
  standalone: true,
    imports: [
        NgIf
    ],
  templateUrl: './app-loader.component.html',
  styleUrl: './app-loader.component.scss'
})
export class AppLoaderComponent {

  private subscription: Subscription;

  protected currentStatus =false;
  constructor(private appLoaderService: AppLoaderService) {

  }

  ngOnInit(): void {
    this.subscription = this.appLoaderService.data$.subscribe(data => {

      this.currentStatus = data;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
